import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import ProductRow from "./ProductRow"

const Products = () => {
  const data = useStaticQuery(graphql`
    query ProductQuery {
      allContentfulProductGallery {
        edges {
          node {
            productRows {
              imagesSameHeight
              products {
                productName
                productImage {
                  fluid {
                    src
                    srcSet
                    srcSetWebp
                    srcWebp
                    tracedSVG
                    sizes
                    base64
                    aspectRatio
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const { productRows } = data.allContentfulProductGallery.edges[0].node

  return (
    <div className="c-product__grid">
    {
      productRows.map((row, idx) => <ProductRow key={idx} sameHeight={row.imagesSameHeight} products={row.products} />)
    }
    </div>
  )
}

export default Products
